import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { environment } from '../../environment';

const OKTA_CONFIG: OktaAuthOptions = {
  scopes: ['openid', 'email', 'profile', 'offline_access'],
  issuer: environment.VITE_OKTA_DOMAIN,
  clientId: environment.VITE_OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/login/callback`,
  pkce: true,
};

export const oktaAuth = new OktaAuth(OKTA_CONFIG);
